import { BusinessPropertiesObject } from './business-properties/business-properties-object.model';
import { ClientPropertiesObject } from './client-properties/client-properties-object.model';
import { ErrorPropertiesObject } from './error-properties/error-properties-object.model';
import { TaskPropertiesObject } from './task-properties/task-properties-object.model';

export class TaskPropertyObject {

    constructor(private businessProperties: BusinessPropertiesObject, private clientProperties: ClientPropertiesObject,
        private errorProperties: ErrorPropertiesObject, private taskProperties: TaskPropertiesObject) {
    }

    public static create(): TaskPropertyObject {
        return new TaskPropertyObject(BusinessPropertiesObject.create(), ClientPropertiesObject.create(),
            ErrorPropertiesObject.create(), TaskPropertiesObject.create());
    }

    getBusinessProperties(): BusinessPropertiesObject {
        return this.businessProperties;
    }

    getClientProperties(): ClientPropertiesObject {
        return this.clientProperties;
    }

    getErrorProperties(): ErrorPropertiesObject {
        return this.errorProperties;
    }

    getTaskProperties(): TaskPropertiesObject {
        return this.taskProperties;
    }
}
